export default "<h3>March 12, 2023</h3>\r\n<p>Version 1.0 is the initial release of Left Turn Legend.</p>";